export const classes = {
  svg: 'size-4 fill-current select-none inline-block shrink-0 text-2xl',
};
